import React, { Component } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { formatDate, formatTime } from '../../constant/dateTime';

import CheckCircleRoundedIcon from '@material-ui/icons/CheckCircleRounded';

// StyleSheet
import '../StatusContent/StatusContent.css';

class StatusContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            INITIAL: {
                title: "Document Processing Started", 
                desc: "Your requested document is being processed."
            },
            PRINT_QR: {
                title: "Request Processed", 
                desc: "QR Code available for your document and will be handed over to our rider.",
            },
            READY_FOR_PICKUP: {
                title: "Document is ready for pick up",
                desc: "Will be out for delivery soon."
            },
            DOCUMENT_SCANNED: {
                title: "Document has already been picked up by our rider.",
                desc: "Your document is arriving soon!"
            },
            IN_TRANSIT: {
                title: "Document is being delivered",
                desc: "Our rider will attempt to deliver your document today! Please keep your lines open so our rider can contact you. If you are not available, please have an authorized representative to receive on your behalf."
            },
            DELIVERED: {
                title: "Document has been delivered",
                desc: "We're happy to serve you and safely deliver your document."
            },
            DELIVERY_ATTEMPT_FAILED: {
                title: "Delivery attempt unsuccessful",
                desc: "Our rider will try to deliver the document today. Please keep your lines open. Updates will be sent via SMS and Email."
            },
            RETURN_TO_OFFICE: {
                title: "Document has been returned to office",
                desc: `Delivery has failed. Your document will be returned to QC BPLD. Kindly contact QC BPLD on +63 9616207220 and +63 9684364161 or send an email to records.bpld@quezoncity.gov.ph. Thank you.\n\n${this.props.departmentName}\nAddress: ${this.props.departmentAddress}`
            },
            FAILED_DELIVERY: {
                title: "Delivery failed!",
                desc: `Kindly contact QC BPLD  on +63 9616207220 and +63 9684364161 or send an email to records.bpld@quezoncity.gov.ph. Thank you.\n\n${this.props.departmentName}\nAddress: ${this.props.departmentAddress}`
            }
        }
    }
    
    render () {
        return (
            <Grid container direction="row" className="details__row--status clearfix">
                {
                    this.props.docActivities.map((doc, index, arr) => {
                        const statusDesc = this.state[doc.documentStatus];
                        
                        return (
                            <Grid 
                                key={index} 
                                container 
                                spacing={1}
                                direction="row"
                                style={{margin: "0 auto", paddingBottom: "15px"}}
                                className="to__last--activity-item"
                                >
                                <Grid item xs={12} sm={9} md={9} lg={9}>
                                    <Grid container direction="row" nowrap="true">
                                        <Grid item xs={2} sm={1}>
                                            <CheckCircleRoundedIcon className="CheckCircleRoundedIcon" />
                                            </Grid>    
                                        <Grid item xs={10} sm={11}>
                                            <Typography component="h1" variant="h5" style={{ textAlign: "left" }}>
                                                {statusDesc.title}
                                            </Typography>
                                            <Typography variant="body1">
                                                {statusDesc.desc}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} sm={3} md={3} lg={3}>
                                    <Grid container direction="row" nowrap="true">
                                        <Grid item xs={2} sm={1}></Grid>
                                        <Grid item xs={10} sm={11}>
                                            <Typography component="h1" variant="h6">
                                                {formatDate(doc.activityTimestamp)}
                                            </Typography>
                                            <Typography variant="body1" gutterBottom>
                                                {formatTime(doc.activityTimestamp)}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    }).reverse()
                }
            </Grid>
        )
    }
} 

export default StatusContent;